<div class="time-picker">
  <input
    type="number"
    id="hour"
    class="form-control"
    [(ngModel)]="selectedHour"
    min="0"
    max="23"
    (input)="validateHour()"
  />
  <span class="text"> :</span>
  <input
    type="number"
    id="minute"
    class="form-control"
    [(ngModel)]="selectedMinute"
    min="0"
    max="59"
    (input)="validateMinute()"
  />
</div>
